/**
 * Unsticky sidebar if taller than window height.
 * 
 * This script manages the sticky behavior of the sidebar by making it unsticky
 * if its height exceeds the window height. It is typically used in themes where
 * custom sticky navigation or sidebar behavior is implemented, and where the 
 * default sticky nav behavior from the ElonUniversity-Base theme is not used.
 * 
 * The ElonUniversity-Base theme includes a built-in sticky navigation script
 * (assets/js/global/components/widgets/StickyNav/src/jquery.StickyNav.js) 
 * that handles removing the sticky behavior for tall sidebars. This script 
 * is provided for themes that might implement sticky nav or sidebar through 
 * their own styles or scripts.
 * 
 * Key Features:
 * - Adds or removes a 'position-relative' class to the sidebar based on its 
 *   height compared to the window height.
 * - Listens to window resize events to update the sidebar's sticky behavior.
 * - Applies the unsticky behavior with a slight delay after the page load to
 *   account for dynamic content changes.
 * 
 * Usage:
 * - Include this script in themes where custom sticky sidebar behavior is needed
 *   and where the default sticky nav handling from ElonUniversity-Base is not 
 *   suitable or applicable.
 */
$(function() {
	
    function unstickySidebar() {
		var windowHeight = $(window).height();
		
		if ($('#pageSidebar').outerHeight() >= windowHeight) {
			$('#pageSidebar').addClass('position-relative');
		} else {
			$('#pageSidebar').removeClass('position-relative');
		}
	}

	// Window listeners	
	$(window).resize(function(){
		unstickySidebar();
	});
    
    // Initialize this after the accordion nav menu has been expanded
    $(window).on('load', function() {
        setTimeout(unstickySidebar, 500);
    });

});